var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M23 8.615H1m5.923-4.23V1m10.154 3.385V1M1 6.077v13.538A3.385 3.385 0 0 0 4.385 23h15.23A3.385 3.385 0 0 0 23 19.615V6.077a3.385 3.385 0 0 0-3.385-3.385H4.385A3.385 3.385 0 0 0 1 6.077"
})));
export default SvgCalendarIcon;